import { ConnectedAdmin } from '@/types/profile.types';
import { PayloadAction, ReducerCreators } from '@reduxjs/toolkit';
import { ConnectedAdminsState } from './types';

export const reducers = (create: ReducerCreators<ConnectedAdminsState>) => ({
  setConnectedAdmins: create.reducer((state, action: PayloadAction<ConnectedAdmin[]>) => {
    state.admins = action.payload;
  }),
  addConnectedAdmin: create.reducer((state, action: PayloadAction<ConnectedAdmin>) => {
    const admins = new Map(state.admins.map((admin) => [admin.brandlive_profile, admin]));
    admins.set(action.payload.brandlive_profile, action.payload);
    state.admins = Array.from(admins.values());
  }),
  removeConnectedAdmin: create.reducer((state, action: PayloadAction<ConnectedAdmin>) => {
    const admins = new Map(state.admins.map((admin) => [admin.brandlive_profile, admin]));
    admins.delete(action.payload.brandlive_profile);
    state.admins = Array.from(admins.values());
  }),
});
